import { render, staticRenderFns } from "./CancelarMarcacao.vue?vue&type=template&id=3276c21a&"
import script from "./CancelarMarcacao.vue?vue&type=script&lang=js&"
export * from "./CancelarMarcacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports